module.exports = __webpack_public_path__ + "img/quicktime.8c6d24f3.png";